import request from  '../request'

export function getHome(){
    return request({
        method:'GET',
        url:'/home'
    })
}